// ── 로그인 전 화면이 쓰는 이 사이트의 간판 (2026-10-29) ─────────────────────────────
// /api/site-info 의 name·logo = 장부의 운영 테넌트 간판 이름·로고(테넌트 관리 → [브랜딩]).
//   미팅링크 = '미팅링크' + 미팅링크 로고 / 파인그룹 = '(주)파인그룹' + 파인 아이콘.
//   받기 전·실패 땐 빈 값 — 다른 사이트 이름·로고가 잠깐 비치지 않게. LoginPage.js 에서 떼어냄(300줄 규칙).
import { useEffect, useState } from 'react';
import { apiClient } from '../api/apiClient';

export function useSiteInfo() {
  const [info, setInfo] = useState({ name: '', logo: '' });
  useEffect(() => {
    let alive = true;
    apiClient.get('/api/site-info').then((res) => {
      if (!alive || !res.ok) return;
      const data = res.data?.data || {};
      setInfo({ name: String(data.name || '').trim(), logo: String(data.logo || '').trim() });
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return info;
}

export default useSiteInfo;
